(function () {
  if (customElements.get('dj-keep-shopping-size')) return;

  class DJKeepShoppingSize extends HTMLElement {
    connectedCallback() {
      this.maxPerRowDesktop = parseInt(this.dataset.productsToShowDesktop || this.dataset.productsToShow || '5', 10) || 5;
      this.maxPerRowMobile = parseInt(this.dataset.productsToShowMobile || '4', 10) || 4;
      this.sizeOptionIndex = parseInt(this.dataset.sizeOptionIndex || '-1', 10);
      this.productInfo = document.querySelector('product-info[id^="MainProduct"], product-info');
      this.variantSelects = this.productInfo?.querySelector('variant-selects') || document.querySelector('variant-selects');

      this.boundScheduleUpdate = this.scheduleUpdate.bind(this);
      this.boundResizeUpdate = this.scheduleUpdate.bind(this);
      this.variantSelects?.addEventListener('change', this.boundScheduleUpdate);
      window.addEventListener('resize', this.boundResizeUpdate);

      document.addEventListener('change', (event) => {
        if (event.target?.closest?.('variant-selects')) this.scheduleUpdate();
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.productInfo = document.querySelector('product-info[id^="MainProduct"], product-info') || this.productInfo;
          this.update(event?.data?.variant);
        });
      }

      this.update();
    }

    disconnectedCallback() {
      this.variantSelects?.removeEventListener('change', this.boundScheduleUpdate);
      window.removeEventListener('resize', this.boundResizeUpdate);
      this.unsubscribeVariantChange?.();
    }

    scheduleUpdate() {
      window.setTimeout(() => this.update(), 180);
    }

    getCurrentSize(variant) {
      if (variant?.options && this.sizeOptionIndex >= 0) {
        return variant.options[this.sizeOptionIndex] || this.dataset.currentSize || '';
      }

      const selectedVariantJson = this.productInfo?.querySelector('variant-selects [data-selected-variant]')?.textContent;
      if (selectedVariantJson) {
        try {
          const selectedVariant = JSON.parse(selectedVariantJson);
          if (selectedVariant?.options && this.sizeOptionIndex >= 0) {
            return selectedVariant.options[this.sizeOptionIndex] || this.dataset.currentSize || '';
          }
        } catch (error) {
          // Use fallback below.
        }
      }

      const optionFieldsets = this.variantSelects?.querySelectorAll('.product-form__input') || [];
      const optionGroup = optionFieldsets[this.sizeOptionIndex];
      const checked = optionGroup?.querySelector('input[type="radio"]:checked');
      if (checked?.value) return checked.value;
      const select = optionGroup?.querySelector('select');
      if (select?.value) return select.value;

      return this.dataset.currentSize || '';
    }

    replaceTokens(template, size) {
      const type = this.dataset.productType || '';
      const brand = this.dataset.productVendor || '';
      return (template || '')
        .replaceAll('[size]', size || '')
        .replaceAll('[type]', type)
        .replaceAll('[brand]', brand)
        .replace(/\s+/g, ' ')
        .trim();
    }

    normaliseFilterParam(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '') || 'size';
    }

    updateSeeAllLink(row, size) {
      const link = row.querySelector('[data-dj-size-rec-see-all]');
      if (!link) return;

      const baseUrl = row.dataset.seeAllBaseUrl || '/collections/all-products-available-in-market';
      const rowMode = row.dataset.rowMode || '';
      const rowFilter = row.dataset.rowFilter || '';
      const sizeParam = this.dataset.sizeFilterParam || this.normaliseFilterParam('Size');
      const url = new URL(baseUrl, window.location.origin);

      url.searchParams.set(`filter.v.option.${sizeParam}`, size);
      if (rowMode === 'vendor') {
        url.searchParams.set('filter.p.vendor', rowFilter || this.dataset.productVendor || '');
      } else {
        url.searchParams.set('filter.p.product_type', rowFilter || this.dataset.productType || '');
      }

      link.href = `${url.pathname}${url.search}${url.hash}`;

      const label = link.dataset.seeAllLabel || 'See all';
      const rowTitle = row.querySelector('[data-dj-size-rec-row-title]')?.textContent?.trim() || '';
      link.textContent = rowTitle ? `${label} ${rowTitle}` : label;
    }

    readVariantMap(card) {
      const script = card.querySelector('[data-dj-size-rec-variant-map]');
      if (!script) return {};
      try {
        return JSON.parse(script.textContent || '{}');
      } catch (error) {
        return {};
      }
    }

    updateCardForSize(card, size) {
      const variantMap = this.readVariantMap(card);
      const sizeData = variantMap[size];
      if (!sizeData) return;

      const link = card.querySelector('[data-dj-size-rec-link]');
      const image = card.querySelector('[data-dj-size-rec-image]');
      const price = card.querySelector('[data-dj-size-rec-price]');

      if (link && sizeData.url) link.href = sizeData.url;
      if (image && image.tagName === 'IMG' && sizeData.image) image.src = sizeData.image;
      if (price && sizeData.price) price.textContent = sizeData.price;
    }

    cardHasSize(card, size) {
      const values = card.dataset.sizeValues || '';
      return values.includes(`|${size}|`);
    }

    getMaxPerRow() {
      return window.matchMedia('(max-width: 749px)').matches ? this.maxPerRowMobile : this.maxPerRowDesktop;
    }

    update(variant) {
      const size = this.getCurrentSize(variant);
      if (!size) {
        this.hidden = true;
        return;
      }

      const subheading = this.querySelector('[data-dj-size-rec-subheading]');
      if (subheading) subheading.textContent = this.replaceTokens(this.dataset.subheadingTemplate, size);

      const maxPerRow = this.getMaxPerRow();
      let visibleRows = 0;
      this.querySelectorAll('[data-dj-size-rec-row]').forEach((row) => {
        const title = row.querySelector('[data-dj-size-rec-row-title]');
        if (title) title.textContent = this.replaceTokens(row.dataset.titleTemplate, size);
        this.updateSeeAllLink(row, size);

        let visibleCards = 0;
        row.querySelectorAll('[data-dj-size-rec-card]').forEach((card) => {
          const shouldShow = this.cardHasSize(card, size) && visibleCards < maxPerRow;
          if (shouldShow) {
            this.updateCardForSize(card, size);
            card.hidden = false;
            visibleCards += 1;
          } else {
            card.hidden = true;
          }
        });

        row.hidden = visibleCards === 0;
        if (visibleCards > 0) visibleRows += 1;
      });

      this.dataset.currentSize = size;
      this.hidden = visibleRows === 0;
    }
  }

  customElements.define('dj-keep-shopping-size', DJKeepShoppingSize);
})();